/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import React, { useState, useEffect } from "react";
import { Hub } from "aws-amplify";
import { ExclamationIcon } from "@heroicons/react/solid";
import Loading from "../qg-components/src/libs/Loading";
import styled from 'styled-components'
import pic from './login-bg.jpg'
const DivStyled = styled.div`
  background-image: url(${pic});
  background-size: cover;
`
const SignInError = () => {
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationIcon
            className="h-5 w-5 text-yellow-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <p className="text-sm text-yellow-700">
            Incorrect username or password. Try again or click Forgot password
            to reset it.
          </p>
        </div>
      </div>
    </div>
  );
};

export default function SignIn({
  signIn,
  updateFormState,
  goToSignUp,
  goToForgetPassword,
}) {
  const [isSignIn, setIsSignIn] = useState(false); // 是否登陆
  const [signInStatus, setSignInStatus] = useState(true);
  const myHubListenerSignIn = (data) => {
    const { payload } = data;
    if (payload.event === "signIn_failure") {
      setSignInStatus(false)
      setIsSignIn(false)
    };
    if (payload.event === "signIn") setSignInStatus(true);
  };

  useEffect(() => {
    Hub.listen("auth", myHubListenerSignIn);
    return function cleanup() {
      Hub.remove("auth", myHubListenerSignIn);
    };
  });

  return (
    <DivStyled className="xs:min-h-screen sm:h-screen flex flex-col py-12 sm:px-6 lg:px-8">
      {/* logo */}
      <a className="flex items-center" href="https://singularity.ai/">
        <img
          className="h-12 w-auto mr-4"
          src="/logo512.png"
          alt="logo"
        />
        <img
          className="w-auto"
          src="/logo-text.png"
          alt="logo-text"
        />
      </a>
      {/* content */}
      <div className="w-full grid gap-16 grid-cols-1 pt-16 lg:pt-32 lg:flex lg:justify-between lg:px-32">
        {/* left text */}
        <div className="">
          <p className="text-6xl font-black text-white">SingularityAI Cloud</p>
          <p className="text-3xl leading-normal font-semibold text-white pt-16 lg:pt-32 flex flex-col">
            <span>Pathology Review and Report</span>
            <span>Quantitative Image Analysis</span>
            <span>Multimodal Data Analytics</span>
            <span>Prognostic and Predictive Biomarker Modeling</span>
          </p>
        </div>
        {/* form */}
        <div className="bg-white py-8 px-4 shadow lg:w-96 sm:rounded-lg sm:px-10">
          <h2 className="text-3xl font-bold leading-normal text-gray-900 mb-4">
            Sign In
          </h2>
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-cneutral-300"
            >
              Your email
            </label>
            <div className="mt-1">
              <input
                id="email"
                name="email"
                type="emai"
                autoComplete="email"
                required
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
                onChange={(e) => {
                  e.persist();
                  updateFormState(e);
                }}
                placeholder="name@example.com"
              />
            </div>
          </div>

          <div className="pt-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <div className="mt-1">
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                onChange={(e) => {
                  e.persist();
                  updateFormState(e);
                }}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-sprimary-500 focus:border-sprimary-500 sm:text-sm"
                placeholder="Password"
                onKeyPress={(e) => {
                  if (e.code === 'Enter') {
                    setIsSignIn(true);
                    setSignInStatus(true);
                    signIn();
                  }
                }}
              />
            </div>
          </div>

          <div className="pt-4 flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-sprimary-600 focus:ring-sprimary-500 border-gray-300 rounded"
              />
              <label
                htmlFor="remember-me"
                className="ml-2 block text-sm text-gray-900"
              >
                Remember me
              </label>
            </div>
          </div>

          <div className="pt-2">
            <button
              type="submit"
              className="pb-2 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sprimary-600 hover:bg-sprimary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sprimary-500"
              onClick={() => {
                setIsSignIn(true);
                setSignInStatus(true);
                signIn();
              }}
            >
              {isSignIn && <Loading color="white" size="20" className="mr-2" />}
              Sign in
            </button>
            {signInStatus ? (
              ""
            ) : (
              <div className="pt-4">
                <SignInError />
              </div>
            )}
          </div>

          <div className="flex flex-col ">
            <span
              className="text-sm leading-none text-gray-500 hover:text-sprimary-500 cursor-pointer pt-4 pb-2"
              type="button"
              onClick={goToForgetPassword}
            >
              Forgot your password?
            </span>
            <span
              className="text-sm leading-none text-gray-500 hover:text-sprimary-500 cursor-pointer"
              type="button"
              onClick={goToSignUp}
            >
              Create a free account
            </span>
            {/* </p> */}
          </div>
        </div>
      </div>
      {/* @ */}
      <div className="pt-8 lg:pt-16 lg:pl-32 flex items-center">
        <p className="text-xl leading-none text-white mr-2">
          &copy;
          2022
        </p>
        <img className="h-5 mt-1" src="/logo-text.png" alt="logo-text" />
      </div>

    </DivStyled>
  );
}
